import {effect, Injectable, signal} from '@angular/core';
import {form, validateStandardSchema} from '@angular/forms/signals';
import {AppBaseComponent} from '../../shared/components/app-base-component/app-base-component';

@Injectable({
  providedIn: 'root',
})
export class AttributeService extends AppBaseComponent {
  attributes = signal({
    profile_for: [],
    caste: [],
    religion: [],
    relationship_status: [],
    smoking_habit: [],
    drinking_habit: [],
    education: [],
    income: [],
    occupation: [],
    height: [],
    weight: [],
    diet: [],
    complexion: [],
    body_build: [],
  });

  private readonly attributeTypes = [
    'profile_for',
    'drinking_habit',
    'smoking_habit',
    'caste',
    'religion',
    'education',
    // 'income',
    'occupation',
    'height',
    'weight',
    'body_build',
    'complexion',
    'diet',
    'relationship_status',
  ];

  private loadingTypes = new Set<string>();
  private loadedTypes = new Set<string>();

  constructor() {
    super();
    effect(() => {
      if (!this.authService.user()) {
        return;
      }
      this.loadAllAttributes();
    });
  }

  loadAllAttributes() {
    for (const type of this.attributeTypes) {
      this.getAttributes(type);
    }
  }

  getAttributes(type: string) {
    if (this.loadingTypes.has(type) || this.loadedTypes.has(type)) {
      return;
    }
    this.loadingTypes.add(type);
    this.http.get(`attributes/${type}`).subscribe({
      next: (res: any) => {
        this.attributes.update((attrs: any) => ({...attrs, [type]: res}));
        this.loadedTypes.add(type);
        this.loadingTypes.delete(type);
      },
      error: (err) => {
        console.error(`Failed to load attributes for ${type}`, err);
        this.loadingTypes.delete(type);
      },
    });
  }
}
